import { render, staticRenderFns } from "./MaterialRequest.vue?vue&type=template&id=257a4ece"
import script from "./MaterialRequest.vue?vue&type=script&lang=js"
export * from "./MaterialRequest.vue?vue&type=script&lang=js"
import style0 from "./MaterialRequest.vue?vue&type=style&index=0&id=257a4ece&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports